import { putBrands } from '../api/putBrands';

export const setPutBrands = (params, callback) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await putBrands(params);
            
            alert('Сохранено')
          
            if (callback) {
                callback();
            }
        } catch(error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}